const PageLoader = () => {
  return (
    <div className="pageLoader">
      <div className="loading">Loading</div>
    </div>
  );
};

export default PageLoader;
